import { render, staticRenderFns } from "./SP.vue?vue&type=template&id=24359461"
import script from "./SP.vue?vue&type=script&lang=js"
export * from "./SP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports